import type { UseQueryOptions } from "@tanstack/react-query";
import type { UserClaim } from "@/models";
import type { Axios } from "axios";

export const getUserClaims = async (
  axiosInstance: Axios
): Promise<UserClaim> => {
  try {
    const response = await axiosInstance.get<UserClaim>("/me");
    return response.data;
  } catch (error) {
    console.error("Error fetching user claims:", error);
    throw error;
  }
};

export const getUserClaimsQuery = (
  axiosInstance: Axios
): UseQueryOptions<UserClaim> => ({
  queryKey: ["userClaims"],
  queryFn: () => getUserClaims(axiosInstance)
});
